import { getEmail } from '@fukuri-admins/utils/common/cookies';
import { differenceInDays } from '@fukuri-admins/utils/common/date';

/** スヌーズの有効期間（日数） */
const SNOOZE_DAYS = 7;

/** localStorage キーのプレフィックス。ユーザーのメールアドレスを付加してユーザー単位に分離する */
const STORAGE_KEY_PREFIX = 'stress_check_implementation_banner_dismissed_at';

type ReturnType = {
  /** スヌーズ中かどうか（閉じてから7日未満なら true） */
  isSnoozed: boolean;
  /** バナーを閉じてスヌーズを開始する */
  dismiss: () => void;
};

/**
 * ストレスチェック実施バナーのスヌーズ状態を管理するhook。
 * 閉じてから7日間はバナーを非表示にする（ユーザー単位で管理）。
 */
export const useScheduleNotificationBannerDismissal = (): ReturnType => {
  const email = getEmail();
  const storageKey = `${STORAGE_KEY_PREFIX}:${email}`;

  const stored = localStorage.getItem(storageKey);
  const dismissedAt = stored !== null ? Number(stored) : Number.NaN;
  const isSnoozed =
    Number.isFinite(dismissedAt) &&
    differenceInDays({ laterDate: new Date(), earlierDate: new Date(dismissedAt) }) < SNOOZE_DAYS;

  const dismiss = () => {
    localStorage.setItem(storageKey, String(Date.now()));
  };

  return { isSnoozed, dismiss };
};
